/**
 * Function used to create a new SummaryGraphCategory for use in the SummaryGraph component.
 * @param {String} name - The text that will describe this category
 * @param {Number} qty - The quantity of items this particular category has
 * @param {String} style - The style defined in SummaryGraph.css that's going to be applied
 * to the category in the graph and the description header.
 */
export default function SummaryGraphCategory(params = {}) {
  const {
    name,
    qty,
    style,
  } = params;

  this.name = name;
  this.qty = qty;
  this.style = style;
}
